import { createContext } from 'react';
import { ISingleTabContext } from './single.props';

export const SingleTabContext = createContext<ISingleTabContext>({
  data: [],
  ui: 'section',
  activeTabIndex: -1,
  toggleTab: () => {}
});
